import { h } from '../../content/pragma.mjs';
import { getValidSetting } from '../../utils/common.mjs';

const LoginComponent = ({ userData, service, productionMode, niaUrl }) => {
    // Build-time gate (Vite `define` → `true` in PROD bundle, `false` otherwise)
    // tree-shakes the test profile tiles and rodne-cislo form out of the bundle.
    // `productionMode` (runtime) is kept as belt-and-suspenders.
    const showTestAids = !__IS_PROD_BUILD__ && !productionMode;

    return (
        <div>
            {service && (<gov-message className="render-login-service-banner" variant="primary"><h2>{ service.description } ({ service.code })</h2><p>Pro zobrazení služby je třeba přihlášení do portálu.</p></gov-message>)}

            <h1>Přihlášení do portálu</h1>

            <gov-button id="back-button-sign-in" wcag-label="Zpět na předchozí stránku" variant="primary" type="solid" size="s" expanded="false" native-type="button"><gov-icon type="basic" name="box-arrow-right" slot="right-icon"></gov-icon> Zpět </gov-button>
            <gov-tiles>
                {showTestAids && (
                <gov-tile>
                    <form>
                        <input type="hidden" id="formUserData" name="userData" value={userData} />
                        <gov-form-control><gov-form-group><gov-form-input id="rc" name="rc" size="m" variant="secondary" input-type="text" placeholder="7707070177"><p class="gov-text--s" slot="prefix">Rodné číslo:</p></gov-form-input></gov-form-group></gov-form-control>
                        <gov-button id="rcOdeslat" class="spacedbutton" wcag-label="Tlačítko odeslat formulář" variant="primary" type="solid" size="m" expanded="true" native-type="button">Odeslat</gov-button>

                    </form>
                </gov-tile>
                )}
                {showTestAids && (
                <gov-tile>
                    <h3 slot="title">Testovací profily</h3>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test', userData)} >Aaron Schick - jednotka, stavba</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test1', userData)}>Michael Kolník - stavba, která je součástí parcely</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test2', userData)}>Jiří Seidl</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test3', userData)}>Zhang Xiaoxu - právo stavby, které je součástí parcely</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test4', userData)}>Zdeněk Lučný - budova s více čísly popisnými</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test5', userData)}>Zora Hanzlíková - parcely z GP</a></p>
                    <p><a href={getLink('/loginCUZK/fakelogin?logincontext=test6', userData)}>Petr Barandovski - budova bez čp/če</a></p>
                </gov-tile>
                )}

                <gov-tile id="nialogincard">
                    <h4 slot="title">Národní bod pro identifikaci a autentizaci</h4>

                    <img src="/assets/images/identita-obcana.png" alt="Logo identita občana" />

                    <p>Po stisknutí tlačítka "Přihlásit se" budete přesměrováni na přihlášení prostřednictvím Identity občana, kde se přihlásíte Vámi zvoleným identifikačním prostředkem, a následně budete přesměrováni zpět do služby ČÚZK.</p>
                    
                    <gov-button wcag-label="Přihlášení přes NIA" variant="primary" type="solid" size="m" expanded="true" href={getLink(niaUrl, userData)} native-type="submit">Přihlásit se</gov-button>
                </gov-tile>
                
            </gov-tiles>
        </div>
    )
};

const getLink = (link, userData) => link + "&userData=" + userData;
    
export default LoginComponent;
